import React from 'react'
export default function Loader () {
  return (
    <div className='h-svh w-full flex items-center justify-center'>
      <div className='relative flex items-center justify-center'>
        <p className='absolute'>loading</p>
        <span className='absolute transition-all duration-500 rounded-full w-[120px] h-[120px] z-10 animate-spin-slow border-2 border-dotted border-black group-hover/spinner:border-black'>

        </span>
      </div>
    </div>
  )
}
